export default __webpack_public_path__ + "static/media/business-6 copy.ad88e89e.jpg";